<template>
    <div class="bannerad-container" :style="containerStyle" :data-jumpUrl="landUrl" :data-deepLinkUrl="deepLinkUrl">
        <img class="cover" :src="cover"/>
        <span v-if="!tagForbid" class="tag" :style="tagStyle">{{ tagName }}</span>
    </div>
</template>
<script>
import imgUtil from '../../_utils/pic-util'
import { pxToRem } from '../../_utils/element'

export default{
    name: 'bannerAd',
    props: {
        height: {
            type: String,
            default: () => {
                return ''
            }
        }
    },
    data(){
        // 通过调用方传入
        return {
            creatives: [], // 素材数组
            tag: {}, // 标签信息
            tagForbid: true, // 是否禁用标签 
        }
    },
    computed:{
        cover(){
            const realWidth = 700
            const realHeight = 180
            const url = imgUtil.setPicSize(this?.creatives?.[0]?.images?.[0]?.url, realWidth, realHeight)
            return url
        },
        landUrl(){
            return this?.creatives?.[0]?.link
        },
        /**
         * @description 是否允许deepLink唤起
         */
        enableDeepLink(){
            return this?.creatives?.[0]?.enableDeepLink
        },
        /**
         * @description deepLink唤起app端
         */
        deepLinkUrl(){
            return this.enableDeepLink ? this?.creatives?.[0]?.deepLinkUrl : undefined
        },
        fallbackUrl(){
            return this?.creatives?.[0]?.fallbackUrl
        },
        tagName(){
            return this.tag?.name || '广告'
        },
        tagStyle(){
            let styleArr = []
            this.tag.boardColor && styleArr.push(`background-color:${this.tag.boardColor}`)
            this.tag.textColor && styleArr.push(`color:${this.tag.textColor}`)
            return styleArr.join(';')
        },
        containerStyle(){
            const styleArr = []
            if(this.height){
                const heightRem = pxToRem(this.height)
                styleArr.push(`height:${heightRem}rem`)
            }
            return styleArr.join(';')
        },
    }
}
</script>
<style lang="less" scoped>
.bannerad-container{
    width: 100%;
    overflow: hidden;
    position: relative;
    .cover{
        display: block;
        width: 100%;
        height: 100%;
        object-fit: cover;
    }
    .tag{
        display: block;
        height: 30px;
        background: rgba(0,0,0,0.3);
        padding: 0px 6px;
        font-size: 22px; /*px*/
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #FFFFFF;
        line-height: 30px;
        position: absolute;
        bottom: 8px;
        right: 8px;
        z-index: 1;
    }
}
</style>